import { ReactElement } from 'react';
import Icon from '@components/Icon';
import TokenAssetAvatar from '@components/TokenAssetAvatar';
import { TokenAsset } from '@types';
import { getUrlWithBasePathOrPublicUrl } from '@lib/utils';

interface TokenAssetListItemProps {
  onClick?(token: TokenAsset): void;
  selected?: boolean;
  token: TokenAsset;
}

function TokenAssetListItem({
  onClick,
  selected = false,
  token,
}: TokenAssetListItemProps): ReactElement {
  const clickable = Boolean(onClick);

  return (
    <li
      className={`flex py-2 px-4 cursor-${clickable ? 'pointer' : 'default'}`}
      onClick={onClick ? (): void => onClick(token) : undefined}
      role={clickable ? 'button' : 'listitem'}
    >
      <div className="flex flex-col justify-center">
        <TokenAssetAvatar
          name={token.name}
          src={getUrlWithBasePathOrPublicUrl(token.logoURI)}
        />
      </div>
      <div className="flex flex-col justify-center ml-1 text-left">
        <p className="text-smallSemibold font-bold">{token.symbol}</p>
        <p className="text-micro">{token.name}</p>
      </div>
      {selected && (
        <div className="flex flex-1 flex-row justify-end items-center">
          <div className="flex flex-row justify-center items-center w-3 h-3 rounded-full ring-2 ring-white">
            <Icon.Check className="text-white" />
          </div>
        </div>
      )}
    </li>
  );
}

export default TokenAssetListItem;
